"use client";

import { EffectPickerDialog } from "@saas/effect-workbench/components/EffectPicker";
import { EFFECTS_CATALOG } from "@saas/shared/config/effects-catalog";
import { ArrowLeftRightIcon } from "lucide-react";
import { useTranslations } from "next-intl";
import Image from "next/image";
import { useState } from "react";

export function ImageEffectHeading({ href }: { href: string }) {
	const t = useTranslations();
	const [open, setOpen] = useState(false);
	const effect = EFFECTS_CATALOG.find((item) => item.href === href);
	if (!effect) {
		return null;
	}

	return (
		<>
			<div className="flex items-center gap-3 rounded-xl border border-zinc-200 bg-white p-2">
				<Image
					src={effect.icon ?? effect.poster}
					alt=""
					width={48}
					height={48}
					sizes="48px"
					className="size-12 shrink-0 rounded-lg object-cover"
				/>
				<h1 className="min-w-0 flex-1 text-base font-semibold leading-snug">
					{t(effect.titleKey)}
				</h1>
				<button
					type="button"
					onClick={() => setOpen(true)}
					className="flex shrink-0 items-center gap-1.5 rounded-lg px-2.5 py-2 text-sm font-medium text-blue-600 hover:bg-blue-50"
				>
					<ArrowLeftRightIcon className="size-4" />
					{t("effectWorkbench.switch")}
				</button>
			</div>
			<EffectPickerDialog
				open={open}
				onOpenChange={setOpen}
				currentHref={href}
			/>
		</>
	);
}
